<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <table id="ni-product-services-table">
      <thead>
        <tr>
          <th>Line No.</th>
          <th class="select-checkbox-cell">
            <b-checkbox
              ref="selectAllChecked"
              v-model="selectAllChecked"
              type="is-info"
              size="is-large"
            ></b-checkbox>
          </th>
          <th v-for="columnData in productServicesColumns" :key="columnData.id">
            <label>{{ columnData.label }}</label>
          </th>
        </tr>
      </thead>
      <tbody class="product-services-table-body">
        <tr
          v-for="(productServiceRow, index) in productServiceRows"
          :key="productServiceRow.id"
          :class="[
            productServiceRow.psQstnId
              ? 'productServiceRow-' + productServiceRow.psQstnId
              : 'newRow',
            productServiceRow.rejectedBy === loginNetworkId &&
            (productServiceRow.apprvlStatus === 'R' ||
              productServiceRow.indStatus === 'Rejected')
              ? 'lock-partial-row'
              : '',
            productServiceRow.rejectedBy !== loginNetworkId &&
            (productServiceRow.apprvlStatus === 'R' ||
              productServiceRow.indStatus === 'Rejected')
              ? 'lock-row'
              : ''
          ]"
          v-bind="productServiceRow.id"
          @click="onRowClick($event)"
          @change="
            !isLoading
              ? changeOnProductServicesRow(
                  $event,
                  index,
                  productServiceRow,
                  productServicesColumns
                )
              : ''
          "
        >
          <ValidationObserver>
            <td class="line-number item-checkbox">
              {{ productServiceRow.lineNumber }}
            </td>
            <td style="display:none;">
              <b-input :value="productServiceRow.psQstnId"></b-input>
            </td>
            <td class="select-checkbox-cell item-checkbox">
              <b-checkbox
                type="is-info"
                size="is-large"
                v-model="checkboxGroup"
                :native-value="productServiceRow.genlQstnId"
              ></b-checkbox>
            </td>
            <td class="line-errors item-checkbox">
              {{ productServiceRow.lineErrors }}
            </td>
            <td>
              <b-input
                ref="firstInput"
                type="text"
                class="vcat"
                :value="productServiceRow.vcat"
                disabled="disabled"
              ></b-input>
            </td>
            <td>
              <b-input
                ref="firstInput"
                type="text"
                class="desc"
                :value="productServiceRow.desc30"
                disabled="disabled"
              ></b-input>
            </td>
            <td class="item-status">
              <ValidationProvider
                rules="oneOf:Approved,Rejected"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="indStatus"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="productServiceRow.indStatus"
                    class="apprvlStatus"
                    @input="
                      productServiceRow.indStatus === 'Rejected'
                        ? (productServiceRow.rejectedBy = loginNetworkId)
                        : (productServiceRow.rejectedBy = '')
                    "
                    :tabindex="
                      productServiceRow.rejectedBy !== loginNetworkId &&
                      (productServiceRow.apprvlStatus === 'R' ||
                        productServiceRow.indStatus === 'Rejected')
                        ? -1
                        : 0
                    "
                  >
                    <option value="Not Reviewed">Not Reviewed</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td class="item-rejection-reason">
              <ValidationProvider
                rules="required_if:indStatus,Rejected"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-tooltip
                    :label="
                      productServiceRow.rejectionReason
                        ? productServiceRow.rejectionReason
                        : ''
                    "
                    type="is-light"
                    position="is-bottom"
                  >
                    <b-input
                      class="rejectionReason"
                      :value="productServiceRow.rejectionReason"
                      @change.native="
                        productServiceRow.rejectionReason = $event.target.value
                      "
                      :disabled="disableOnStatus(productServiceRow)"
                      :tabindex="
                        productServiceRow.rejectedBy !== loginNetworkId &&
                        (productServiceRow.apprvlStatus === 'R' ||
                          productServiceRow.indStatus === 'Rejected')
                          ? -1
                          : 0
                      "
                    ></b-input>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="uncondCat"
                    oninput="this.value = this.value.replace('.', '');"
                    @input.native="validateUncondCat"
                    :value="productServiceRow.uncondCat"
                    @change.native="
                      productServiceRow.uncondCat = $event.target.value
                    "
                    :tabindex="productServiceRow.apprvlStatus === 'R' ? -1 : 0"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="fcat"
                    :class="[
                      productServiceRow.fcatError === 'Dup Fcat'
                        ? 'is-danger'
                        : '',
                      productServiceRow.fcatError === 'FCAT' ? 'is-danger' : ''
                    ]"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, ''); if (this.value.length > 11)
                        this.value = this.value.slice(0, 11);"
                    :value="productServiceRow.fcat"
                    @change.native="
                      productServiceRow.fcat = $event.target.value
                    "
                    :tabindex="productServiceRow.apprvlStatus === 'R' ? -1 : 0"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                    class="ibm"
                    :value="productServiceRow.ibm"
                    @change.native="productServiceRow.ibm = $event.target.value"
                    :tabindex="productServiceRow.apprvlStatus === 'R' ? -1 : 0"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:A90,A92,C75"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="pbSec"
                    v-model="productServiceRow.pbSec"
                    :value="
                      productServiceRow.pbSec === undefined
                        ? (productServiceRow.pbSec = ' ')
                        : productServiceRow.pbSec
                    "
                    :tabindex="productServiceRow.apprvlStatus === 'R' ? -1 : 0"
                  >
                    <option value=" "></option>
                    <option value="A90">A90</option>
                    <option value="A92">A92</option>
                    <option value="C75">C75</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="psComments"
                :value="productServiceRow.internalComments"
                @change.native="
                  productServiceRow.internalComments = $event.target.value
                "
                :tabindex="productServiceRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                class="psdeletionComments"
                :value="productServiceRow.deletionComments"
                disabled="disabled"
              ></b-input>
            </td>
          </ValidationObserver>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
import BSelect from "buefy/src/components/select/Select";
import BInput from "buefy/src/components/input/Input";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
extend("required", {
  validate(value) {
    return {
      required: true,
      valid: [" ", "", null, undefined, 0].indexOf(value) === -1
    };
  },
  computesRequired: true
});

extend("regexUpto4Decimals", {
  validate(value) {
    return {
      required: true,
      valid: /^\d*\.?\d{0,4}$/.test(value)
    };
  },
  computesRequired: true
});

extend("regexUpto2Decimals", {
  validate(value) {
    return {
      required: true,
      valid: /^\d*\.?\d{0,2}$/.test(value)
    };
  },
  computesRequired: true
});

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

export default {
  name: "ProductServicesTabComponent",
  components: { BSelect, BInput },
  data() {
    return {
      isLoading: false,
      selectAllChecked: false,
      checkboxGroup: [],
      selectedRows: [],
      generalQuestionRows: [],
      productServiceRows: [],
      rowIds: [],
      paginationParams: [],
      isFcatNexInSeries: false,
      loginNetworkId: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").networkId
        : "",
      loginNameUser: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").nameUser
        : "",
      productServicesColumns: [
        { label: "Line Errors", col: "lineErrors" },
        { label: "Supplier Catalog Number", col: "vcat" },
        { label: "Item Description 30", col: "lineErrors" },
        { label: "Approval Status", col: "indStatus" },
        { label: "Rejection Reason", col: "rejectionReason" },
        {
          label: "Uncondensed Catalog Number",
          title:
            "The uncondensed Fisher catalog number should be formatted as follows: XX XXX XXXXX – See the Part Number Data Governance for more details.",
          col: "uncondCat"
        },
        {
          label: "Fisher Catalog Number",
          title:
            "A unique catalog number typically assigned by Product Administration Requests for specific catalog numbers can be entered here or in the Suggested Fisher Catalog Number Series Assignment.",
          col: "fcat"
        },
        {
          label: "IBM Number",
          title:
            "unique number assigned to a product by Product Administration",
          col: "ibm"
        },
        {
          label: "Price Book Section",
          title:
            "denotes where an item is located in the price book If none entered, Product Administration will assign.",
          col: "pbSec"
        },
        { label: "Comments", col: "internalComments" },
        { label: "Deletion Comments", col: "deletionComments" }
      ]
    };
  },
  props: ["submissionIdForProductServices", "loadProductServicesData"],
  watch: {
    selectAllChecked: function(isChecked) {
      if (isChecked) {
        this.checkboxGroup = this.rowIds;
      } else {
        this.checkboxGroup = [];
      }
      this.$emit("selectedRowIdsForProductServices", this.checkboxGroup);
    },
    checkboxGroup: function() {
      this.$emit("selectedRowIdsForProductServices", this.checkboxGroup);
    },
    loadProductServicesData(value) {
      if (value.loadDetails) {
        this.generalQuestionRows = value.generalQuestionRows;
        this.actions = value.actions;
        this.paginationParams = value.paginationParams;
        if (value.validatePSData) {
          this.renderFromValidateObj(value.validatePSData);
        } else {
          this.loadProductServicesUnderSubmission();
        }
      }
    }
  },
  methods: {
    onRowClick: function(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].closest("tr").classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    changeOnProductServicesRow(event, index, rowData, productServicesColumns) {
      var rowArrayFromResponse = JSON.parse(
        sessionStorage.getItem("productServiceRows")
      );
      if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(
          sessionStorage.getItem("productServiceRows")
        )[index];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "psfsNewItemGenlQstnErrTbs" &&
            key !== "lineNumber" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            if (
              !(
                rowDataFromResponseObj[key] === undefined &&
                rowData[key] === " "
              )
            ) {
              if (rowData[key] === " ") {
                rowData[key] = "";
              }
              rowData.updatedColumnName = key;
              rowData.updatedValue = rowData[key];
              for (let i = 0; i < productServicesColumns.length; i++) {
                if (productServicesColumns[i].col === key)
                  rowData.columnDesc = productServicesColumns[i].label;
              }
              this.updateProductServicesItem(rowData, index);
              break;
            }
          }
        }
      }
    },
    loadProductServicesUnderSubmission() {
      this.checkboxGroup = [];
      this.selectAllChecked = false;
      this.selectedRows = [];
      this.$emit("selectedRowIdsForProductServices", this.checkboxGroup);
      var productServicesScope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var requestPayload = {};
      requestPayload.actions = [];
      requestPayload.filterMap = {};
      requestPayload.searchMap = {};
      requestPayload.sortMap = {};
      if (this.actions.fErrors || this.actions.fLineErrors) {
        requestPayload.actions.push("Filter");
        if (this.actions.fErrors) {
          requestPayload.filterMap.ErroredItems = this.actions.fErrors;
        }
        if (this.actions.fLineErrors) {
          requestPayload.sortMap.lineErrors = this.actions.fLineErrors;
        }
      }

      productServicesScope.isLoading = true;
      productServicesScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}productService/submissionId/${productServicesScope.submissionIdForProductServices}?pageNbr=${productServicesScope.paginationParams.pageIndex}&pageSize=${productServicesScope.paginationParams.numberOfPSItems}`,
          requestPayload,
          args
        )
        .then(function(response) {
          var psPaginationParams = {
            startIndex: response.data.startIndex,
            endIndex: response.data.endIndex,
            totalCount: response.data.totalCount,
            totalPages: response.data.totalPages
          };
          productServicesScope.$emit("psPaginationParams", psPaginationParams);
          productServicesScope.isLoading = false;
          productServicesScope.productServiceRows = [];
          productServicesScope.rowIds = [];

          if (window.$cookies.get("ni_key")) {
            //enable/disable submit button
            if (window.$cookies.get("ni_key").roleKey === 6) {
              if (window.isSubmissionActiveForPS) {
                //emit error count
                productServicesScope.$emit(
                  "psTabErrorCount",
                  response.data.errorCount
                );
              }
            }
          } else if (
            sessionStorage.getItem("se_ni_user") &&
            window.showPSTabInReadOnly
          ) {
            //emit error count
            productServicesScope.$emit(
              "psTabErrorCount",
              response.data.errorCount
            );
          }

          var mutableResponseRows = response.data.psfsNewItemPSQstnsTbs;
          if (requestPayload.actions.length > 0) {
            if (response.data.psfsNewItemPSQstnsTbs.length > 0) {
              for (
                var i = 0, lineNumber = psPaginationParams.startIndex;
                i < mutableResponseRows.length && lineNumber > 0;
                i++, lineNumber++
              ) {
                if (
                  !(
                    mutableResponseRows[i].rejectedBy !==
                      productServicesScope.loginNetworkId &&
                    (mutableResponseRows[i].apprvlStatus === "R" ||
                      mutableResponseRows[i].indStatus === "Rejected")
                  )
                ) {
                  productServicesScope.rowIds.push(
                    mutableResponseRows[i].genlQstnId
                  );
                }
                mutableResponseRows[i].lineNumber = lineNumber;
                /*mutableResponseRows[i].fcat
                  ? (mutableResponseRows[i].fcat = mutableResponseRows[
                      i
                    ])
                  : "";*/
              }
              productServicesScope.productServiceRows = mutableResponseRows;
              sessionStorage.setItem(
                "productServiceRows",
                JSON.stringify(response.data.psfsNewItemPSQstnsTbs)
              );
            } else {
              productServicesScope.productServiceRows = [];
            }
          } else {
            if (response.data.psfsNewItemPSQstnsTbs.length > 0) {
              for (
                var j = 0, lineNumberJ = psPaginationParams.startIndex;
                j < mutableResponseRows.length && lineNumberJ > 0;
                j++, lineNumberJ++
              ) {
                if (
                  !(
                    mutableResponseRows[j].rejectedBy !==
                      productServicesScope.loginNetworkId &&
                    (mutableResponseRows[j].apprvlStatus === "R" ||
                      mutableResponseRows[j].indStatus === "Rejected")
                  )
                ) {
                  productServicesScope.rowIds.push(
                    mutableResponseRows[j].genlQstnId
                  );
                }
                mutableResponseRows[j].lineNumber = lineNumberJ;
                /*mutableResponseRows[j].fcat
                  ? (mutableResponseRows[j].fcat = mutableResponseRows[
                      j
                    ])
                  : mutableResponseRows[j].fcat;*/
              }
              productServicesScope.productServiceRows = mutableResponseRows;
              sessionStorage.setItem(
                "productServiceRows",
                JSON.stringify(response.data.psfsNewItemPSQstnsTbs)
              );
            } else {
              productServicesScope.productServiceRows = [];
              sessionStorage.removeItem("productServiceRows");
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          productServicesScope.isLoading = false;
          productServicesScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load items for Submission - ${productServicesScope.submissionIdForProductServices}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          //focus on first editable apprvlStatus field
          if (!$(".ni-app-product-services-tab").hasClass("viewOnly")) {
            $(".product-services-table-body")
              .children("tr:not(.lock-row):not(.lock-partial-row)")
              .first()
              .find("td:has(.apprvlStatus select)")
              .find("select")
              .focus();
          }

          //custom navigator plugin using jquery
          (function($) {
            $.fn.enableCellNavigation = function() {
              var arrow = {
                left: 37,
                up: 38,
                right: 39,
                down: 40
              };
              var esc = 27;

              // select all on focus
              // works for elements and will put focus into
              // adjacent input or select
              this.find("input,select").keydown(function(e) {
                // shortcut for key other than arrow keys
                if (
                  $.inArray(e.which, [
                    arrow.left,
                    arrow.up,
                    arrow.right,
                    arrow.down,
                    esc
                  ]) < 0
                ) {
                  return;
                }

                var input = e.target;
                var td = $(e.target).closest("td");
                var moveTo = null;

                switch (e.which) {
                  case arrow.left: {
                    if (
                      ($(input).is("input:text") &&
                        input.selectionStart !== 0) === false
                    ) {
                      //left on checkbox
                      if (td.index() === 2) {
                        //if lock-partial-row
                        if (
                          td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row)")
                            .first()
                            .hasClass("lock-partial-row")
                        ) {
                          //go to rejectionReason field on lock-partial-row
                          moveTo = td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row)")
                            .first("tr")
                            .find("td:has(.rejectionReason input)");
                        } else {
                          //go to last input of prev row whose input is not disabled
                          moveTo = td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row):not(.lock-partial-row)")
                            .first("tr")
                            .find("td:has(input:not(:disabled))")
                            .last();
                        }
                      }
                      //left on status field
                      else if (td.index() === 6) {
                        //go to checkbox field
                        moveTo = td.prevAll("td:has(input:checkbox)");
                      }
                      //left on input, select
                      else {
                        //left on input, select of disabled fields
                        if (td.prev("td:has(input,select)").has(":disabled")) {
                          //go to prev input, select with no disabled prop
                          moveTo = td.prevAll(
                            "td:has(input:not(:disabled),select:not(:disabled))"
                          );
                        } else {
                          //go to prev input, select
                          moveTo = td.prev("td:has(input,select)");
                        }
                      }
                    }
                    break;
                  }
                  case arrow.right: {
                    if (
                      ($(input).is("input:text") &&
                        input.selectionStart !== input.value.length) === false
                    ) {
                      //right on checkbox field
                      if (td.index() === 2) {
                        moveTo = td.nextAll("td:has(.apprvlStatus select)");
                      }
                      //right on rejectionReason field
                      else if (td.index() === 7) {
                        //if lock-partial-row
                        if (td.parents("tr").hasClass("lock-partial-row")) {
                          //go to checkbox field on next row
                          //skip lock-row
                          moveTo = td
                            .parents("tr")
                            .nextAll("tr:not(.lock-row)")
                            .find("td:has(input:checkbox)");
                        } else {
                          //go to next input that is not disabled
                          //skip lock-row
                          moveTo = td.next("td:has(input:not(:disabled))");
                        }
                      }
                      //right on input, select
                      else {
                        //right on input, select of disabled fields
                        if (td.next("td:has(input,select)").has(":disabled")) {
                          moveTo = td.nextAll(
                            "td:has(input:not(:disabled),select:not(:disabled))"
                          );
                          //if right on last field
                          if (moveTo.length === 0) {
                            //go to next row checkbox field
                            //skip lock-row
                            moveTo = td
                              .parents("tr")
                              .nextAll("tr:not(.lock-row)")
                              .find("td:has(input:checkbox)");
                          }
                        } else {
                          //go to next input, select
                          moveTo = td.next("td:has(input,select)");
                        }
                      }
                    }
                    break;
                  }

                  case arrow.up:
                  case arrow.down: {
                    e.preventDefault();
                    var tr = td.closest("tr");
                    var pos = td.index();

                    var moveToRow = null;
                    //skip over rejected rows on up/down
                    if (e.which == arrow.down) {
                      moveToRow = tr.nextAll(
                        "tr:not(.lock-partial-row):not(.lock-row)"
                      );
                    } else if (e.which == arrow.up) {
                      moveToRow = tr.prevAll(
                        "tr:not(.lock-partial-row):not(.lock-row)"
                      );
                    }

                    if (moveToRow.length) {
                      moveTo = $(moveToRow[0].children[0].children[pos]);
                    }
                    break;
                  }
                }

                if (moveTo && moveTo.length) {
                  e.preventDefault();
                  var input = $(moveTo[0]).find("input")[0];
                  if (arrow.right === e.which && $(input).is("input:text")) {
                    // var input = $(moveTo[0]).find("input")[0];
                    input.focus();
                    $(input)
                      .get(0)
                      .setSelectionRange(0, 0);
                  } else if (
                    arrow.left === e.which &&
                    $(input).is("input:text")
                  ) {
                    // var input = $(moveTo[0]).find("input")[0];
                    if (typeof input.selectionStart == "number") {
                      input.selectionStart = input.selectionEnd =
                        input.value.length;
                    } else if (typeof input.createTextRange != "undefined") {
                      var range = input.createTextRange();
                      range.collapse(false);
                      range.select();
                    }
                    input.focus();
                  } else if ($(input).is("input:text")) {
                    // var input = $(moveTo[0]).find("input")[0];
                    input.focus();
                  } else {
                    //focus on input, select
                    var input = $(moveTo[0]).find("input,select")[0];
                    input.focus();
                  }
                }
              });
            };
          })($);

          // use the plugin
          $(function() {
            $("#ni-product-services-table").enableCellNavigation();
          });
        });
    },
    renderFromValidateObj(data) {
      var productServicesScope = this;
      var psPaginationParams = {
        startIndex: data.startIndex,
        endIndex: data.endIndex,
        totalCount: data.totalCount,
        totalPages: data.totalPages
      };
      productServicesScope.$emit("psPaginationParams", psPaginationParams);
      productServicesScope.isLoading = false;
      productServicesScope.productServiceRows = [];
      productServicesScope.rowIds = [];

      if (window.$cookies.get("ni_key")) {
        //enable/disable submit button
        if (window.$cookies.get("ni_key").roleKey === 6) {
          if (window.isSubmissionActiveForPS) {
            //emit error count
            productServicesScope.$emit("psTabErrorCount", data.errorCount);
          }
        }
      } else if (
        sessionStorage.getItem("se_ni_user") &&
        window.showPSTabInReadOnly
      ) {
        //emit error count
        productServicesScope.$emit("psTabErrorCount", data.errorCount);
      }

      var mutableResponseRows = data.psfsNewItemPSQstnsTbs;

      if (data.psfsNewItemPSQstnsTbs.length > 0) {
        for (
          var i = 0, lineNumber = psPaginationParams.startIndex;
          i < mutableResponseRows.length && lineNumber > 0;
          i++, lineNumber++
        ) {
          if (
            !(
              mutableResponseRows[i].rejectedBy !==
                productServicesScope.loginNetworkId &&
              (mutableResponseRows[i].apprvlStatus === "R" ||
                mutableResponseRows[i].indStatus === "Rejected")
            )
          ) {
            productServicesScope.rowIds.push(mutableResponseRows[i].genlQstnId);
          }
          mutableResponseRows[i].lineNumber = lineNumber;
          /*mutableResponseRows[i].fcat
                  ? (mutableResponseRows[i].fcat = mutableResponseRows[
                      i
                    ])
                  : "";*/
        }
        productServicesScope.productServiceRows = mutableResponseRows;
        sessionStorage.setItem(
          "productServiceRows",
          JSON.stringify(data.psfsNewItemPSQstnsTbs)
        );
      } else {
        productServicesScope.productServiceRows = [];
      }
    },
    updateProductServicesItem(requestPayload, index) {
      var productServicesScope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };
      requestPayload.updatedBy = productServicesScope.loginNameUser;

      var updatedRowData = {};
      var approverNetworkId = productServicesScope.loginNetworkId;

      /*      requestPayload.indStatus === "Rejected"
        ? (requestPayload.updatedBy = approverNetworkId)
        : "";*/

      var numericRegex = /^[0-9 ]+$/g;
      if (requestPayload.uncondCat && requestPayload.uncondCat > 11) {
        if (numericRegex.test(requestPayload.uncondCat)) {
          requestPayload.uncondCat = requestPayload.uncondCat.slice(0, 11);
        } else {
          requestPayload.uncondCat = requestPayload.uncondCat.slice(0, 13);
        }
      }

      for (var key in requestPayload) {
        var prop = "";
        prop = requestPayload[key];
        if (typeof prop === "string") {
          if (prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      productServicesScope.isLoading = true;
      productServicesScope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}productService/submissionId/${productServicesScope.submissionIdForProductServices}/psQstnId/${requestPayload.psQstnId}/updateProductServices`,
          updatedRowData,
          args
        )
        .then(function(response) {
          productServicesScope.isLoading = false;
          var apiRow = response.data;
          apiRow.lineNumber =
            productServicesScope.productServiceRows[index].lineNumber;
          productServicesScope.productServiceRows[index] = apiRow;
          var psRows = JSON.parse(sessionStorage.getItem("productServiceRows"));
          psRows.splice(index, 1, response.data);
          sessionStorage.setItem("productServiceRows", JSON.stringify(psRows));
          //enable/disable submit button
          if (window.$cookies.get("ni_key").roleKey === 6) {
            if (window.isSubmissionActiveForPS) {
              //emit error count
              productServicesScope.$emit(
                "psTabErrorCount",
                response.data.totalErrorCount
              );
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          productServicesScope.isLoading = false;
          productServicesScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item information for Submission - ${productServicesScope.submissionIdForProductServices}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          var tableRows = document.querySelector(".product-services-table-body")
            .rows;
          for (var row in tableRows) {
            if (
              tableRows[row].classList &&
              tableRows[row].classList.contains("highlight-row")
            ) {
              tableRows[row].classList.remove("highlight-row");
            }
          }
          //add highlight-row class
          document
            .querySelector(".product-services-table-body")
            .rows[index].classList.add("highlight-row");
          //blur select event on active element wrt index
          if (
            document.activeElement.closest("tr") &&
            document.activeElement.closest("tr").rowIndex !== index + 1
          ) {
            document.activeElement.blur();
          }
        });
    },
    disableOnStatus(productServiceRow) {
      if (productServiceRow.indStatus === "Rejected") {
        return false;
      } else {
        return true;
      }
    },
    validateUncondCat(e) {
      var numericRegex = /^[0-9 ]+$/g;
      var value = e.target.value;
      if (numericRegex.test(value)) {
        value = value.replace(/\s/g, "").slice(0, 11);
        // return e.target.value;
      } else {
        value = value.replace(/\s/g, "").slice(0, 13);
        // return e.target.value;
      }
      e.target.value = value;
    }
  }
};
</script>

<style scoped></style>
